import { CartPaymentData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { styles } from './thank-you-modal-styles';

export const getRowsClassName = (payments: CartPaymentData[]): string => {
  const classes = styles();
  switch (payments.length) {
    case 1:
      return classes.singleRow;
    case 2:
      return classes.doubleRow;
    default:
      return classes.multiRow;
  }
};
